import '../scss/theme.scss';
import 'bootstrap';
import mobileMenu from './utils/hcOffcanvasNav';
import lazyload from './utils/lazyload';
import { loadGoogleMaps } from './utils/gmap/map';


document.addEventListener('DOMContentLoaded', () => {
  lazyload();
  mobileMenu('#primary-menu', '.hc-menu-toggle');
});
